
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class AboutMe extends Vue {
  private colors = {
    lightGray: '#b4b4c4',
    darkPurple: '#36134a',
  };

  private country = '';

  private address = '';

  private unit = '';

  private floor = '';

  private buzzer = '';

  private postalCode = '';

  private submit(): void {
    this.$emit('next');
  }
}
